import qs from 'qs'
import SuperagentApi from '../assets/utils/superagent'

const baseURL = _.get(Wiz, 'globalSettings.globalConfig.gxResourceBaseURL') || ''
const superagentApi = new SuperagentApi({ baseUrl: baseURL })
const token = Wiz.AuthHooks.GetToken()
const headers = {
  Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
  'X-Wiz-Tenant-Id': JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || '',
}

export default class ResourceApiService {
  // 获取某一实体类别属性
  static async getClassAndClassTypeAttrDropDowData(payload) {
    const [err, res] = await superagentApi.post(
      '/api/std/StdClass/get-class-and-class-type-attr-drop-dow-data',
      {
        data: payload,
        headers,
      }
    )
    return [err, res]
  }
  // 获取某一类别表数据
  static async getDynamicTableData(payload) {
    const [err, res] = await superagentApi.post(
      '/api/std/StdClassData/dynamic-table-paged-result',
      {
        data: payload,
        headers,
      }
    )
    return [err, res]
  }
  // 获取类别属性2
  static async getDynamicTableHeader(payload) {
    const [
      err,
      res,
    ] = await superagentApi.get(
      `/api/std/StdClassData/dynamic-table-header-info?${qs.stringify(payload)}`,
      { headers }
    )
    return [err, res]
  }
}
